import { __awaiter, __generator, __read, __values } from "tslib";
import { Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { RemoteSourceTypes } from './constants';
import { BIService } from './BIService';
import { FetchError } from '@wix/wixstores-client-core/dist/es/src/http/FetchError';
import { minifyGraphqlQuery } from '../viewer-script/utils';
var BaseApi = /** @class */ (function () {
    function BaseApi(_a) {
        var siteStore = _a.siteStore, origin = _a.origin;
        this.origin = origin;
        this.siteStore = siteStore;
        this.biService = new BIService({ siteStore: siteStore, origin: origin });
    }
    BaseApi.prototype.absoluteUrl = function (url) {
        return this.siteStore.resolveAbsoluteUrl(url);
    };
    Object.defineProperty(BaseApi.prototype, "endpoints", {
        get: function () {
            var _a;
            var _this = this;
            return _a = {},
                _a[RemoteSourceTypes.ScalaReadOnly] = this.absoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL),
                _a[RemoteSourceTypes.ScalaReadWrite] = this.absoluteUrl("/" + Topology.READ_WRITE_GRAPHQL_URL),
                _a[RemoteSourceTypes.NodeReadWrite] = this.absoluteUrl("/" + Topology.NODE_GRAPHQL_URL),
                _a[RemoteSourceTypes.NodeReadWriteForcePlatform] = this.absoluteUrl("/" + Topology.NODE_GRAPHQL_URL + "?forceNodeOnlyResponse=true"),
                _a.cartCommmands = function (command) {
                    return _this.absoluteUrl("" + Topology.CART_COMMANDS_URL.replace('{commandName}', command));
                },
                _a;
        },
        enumerable: false,
        configurable: true
    });
    BaseApi.prototype.post = function (url, data, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.siteStore.httpClient.post(url, data, { queryParams: queryParams }).catch(function (e) {
                            var _a, _b;
                            if ((_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.errors) {
                                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                                throw { success: false, errors: e.data.response.errors };
                            }
                            // eslint-disable-next-line @typescript-eslint/no-throw-literal
                            throw e;
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    BaseApi.prototype.fetch = function (_a, remoteSource, forcePost, selectErrorsFn) {
        var query = _a.query, variables = _a.variables, operationName = _a.operationName;
        if (remoteSource === void 0) { remoteSource = RemoteSourceTypes.ScalaReadWrite; }
        if (forcePost === void 0) { forcePost = false; }
        if (selectErrorsFn === void 0) { selectErrorsFn = function () { return undefined; }; }
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, params, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        endpoint = this.endpoints[remoteSource];
                        params = {
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            source: 'WixStoresWebClient',
                        };
                        if (!(!forcePost && RemoteSourceTypes.NodeReadWrite === remoteSource)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.tryNodeGetGqlAndFallbackToPost(endpoint, params)];
                    case 1:
                        response = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, (forcePost
                            ? this.siteStore.httpClient.post(endpoint, params)
                            : this.siteStore.tryGetGqlAndFallbackToPost(endpoint, params))];
                    case 3:
                        response = (_b.sent());
                        _b.label = 4;
                    case 4:
                        if (selectErrorsFn(response)) {
                            throw new FetchError(selectErrorsFn(response));
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    BaseApi.prototype.mutate = function (params, selectErrorsFn) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch(params, RemoteSourceTypes.NodeReadWrite, true, selectErrorsFn).then(function (res) { return res.data; })];
            });
        });
    };
    BaseApi.prototype.tryNodeGetGqlAndFallbackToPost = function (url, reqData, options) {
        return __awaiter(this, void 0, void 0, function () {
            var query, variables, operationName, queryParams, _a, _b, _c, key, value;
            var e_1, _d;
            var _this = this;
            return __generator(this, function (_e) {
                query = minifyGraphqlQuery(reqData.query);
                variables = reqData.variables
                    ? /* istanbul ignore next: todo(titk@wix.com): remove when there will be at least one Gql Get call with variables */
                        JSON.stringify(reqData.variables)
                    : null;
                operationName = reqData.operationName;
                queryParams = {};
                try {
                    for (_a = __values(Object.entries({
                        query: query,
                        variables: variables,
                        operationName: operationName,
                    })), _b = _a.next(); !_b.done; _b = _a.next()) {
                        _c = __read(_b.value, 2), key = _c[0], value = _c[1];
                        if (value) {
                            queryParams[key] = value;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/, this.siteStore.httpClient
                        .get(url, {
                        queryParams: queryParams,
                    }, false)
                        .catch(
                    /* istanbul ignore next: todo(titk@wix.com): need to consider adding test */ function () {
                        return _this.siteStore.httpClient.post(url, reqData, options);
                    })];
            });
        });
    };
    return BaseApi;
}());
export { BaseApi };
//# sourceMappingURL=BaseApi.js.map